export default "__VITE_ASSET__e843ac42__"